<script setup lang="ts">
import { PhChartBar } from '@phosphor-icons/vue'
import BaseButton from '@/components/common/BaseButton.vue'
import { analyticsAvailable, analyticsConsent, setAnalyticsConsent } from '@/services/analytics'
</script>

<template>
  <!-- Asked once per device; the answer can be changed later in Settings. -->
  <div
    v-if="analyticsAvailable && analyticsConsent === null"
    role="region"
    aria-label="Usage analytics"
    class="consent-banner fixed inset-x-0 bottom-0 z-50 px-3 sm:bottom-4 sm:px-0"
  >
    <div class="mx-auto max-w-md rounded-2xl border border-line-3 bg-surface-2 p-4 shadow-lg">
      <p class="flex items-center gap-2 text-sm font-semibold text-ink">
        <PhChartBar class="h-4 w-4 text-accent-cyan" />
        Help us improve TalentSwap?
      </p>
      <p class="mt-1.5 text-xs leading-relaxed text-ink-5">
        With your OK we count which pages you visit and when you list, order or share, using Mixpanel.
        Never your messages, never for ads. You can change this anytime in Settings.
      </p>
      <div class="mt-3 grid grid-cols-2 gap-2">
        <BaseButton variant="secondary" size="sm" @click="setAnalyticsConsent('denied')">No thanks</BaseButton>
        <BaseButton variant="primary" size="sm" @click="setAnalyticsConsent('granted')">Allow</BaseButton>
      </div>
    </div>
  </div>
</template>

<style scoped>
.consent-banner {
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
}
</style>
